import {
  StatesAction,
  CommonActionType,
  ToggleModalAction,
  AddressVerificationAction,
  AttachFileStartAction,
  AttachFileSuccessAction,
  AttachFileFailureAction,
  SuccessGetResultAction,
  ResetFileAttachFormAction,
  ToggleDialogAction,
  SetFileListLoadingAction
} from '@common/components/common.actions';
import { createReducer } from '@common/redux-utils';
import { ModalProps } from '@common/components/modal/_components/modal.component';
import { AddressViewModel, StatesViewModel } from '@models/common.models';
import { FileViewModel } from '@models/Document';
import { InitGetResultAction, GetResultFailureAction } from '@common/components/common.actions';
import { DialogProperties } from '@common/components/dialog/dialog.component';

export interface CommonState {
  readonly errorMessage?: string;
  readonly states?: StatesViewModel[];
  readonly modalProps?: ModalProps;
  readonly dialogProps?: DialogProperties;
  readonly showModal?: boolean;
  readonly lastVerifiedAddress?: AddressViewModel;
  readonly addressToVerify?: AddressViewModel;
  readonly fileVMs?: FileViewModel[];
  readonly showDialog?: boolean;
  readonly isVerifying?: boolean;
  readonly isLoadingFileList: boolean;
}

// This is the initial state of the page
const initialState: CommonState = {
  dialogProps: {
    text: '',
    textNo: '',
    textYes: 'Ok'
  },
  isLoadingFileList: false
};

function handleLoadStatesStart(state: CommonState, action: StatesAction): CommonState {
  return {
    ...state
  };
}

function handleLoadStatesFailure(state: CommonState, action: StatesAction): CommonState {
  return {
    ...state,
    errorMessage: action.errorMessage
  };
}

function handleLoadStatesSuccess(state: CommonState, action: StatesAction): CommonState {
  return {
    ...state,
    states: action.states
  };
}

function handleToggleModal(state: CommonState, action: ToggleModalAction): CommonState {
  return {
    ...state,
    modalProps: action.modalProps,
    showModal: !state.showModal
  };
}

function handleToggleDialog(state: CommonState, action: ToggleDialogAction): CommonState {
  return {
    ...state,
    dialogProps: action.dialogProps,
    showDialog: !state.showDialog
  };
}

function handleAddressVerificationStart(state: CommonState, action: AddressVerificationAction): CommonState {
  return {
    ...state,
    lastVerifiedAddress: action.addressToVerify,
    isVerifying: true
  };
}

function handleAddressVerificationSuccess(state: CommonState, action: AddressVerificationAction): CommonState {
  if (!action.verifiedAddress) {
    return state;
  }
  return {
    ...state,
    isVerifying: false
  };
}

function handleAddressVerificationFail(state: CommonState, action: AddressVerificationAction): CommonState {
  return {
    ...state,
    isVerifying: false
  };
}

/********** AttachFile **********/
function handleAttachFileStart(state: CommonState, action: AttachFileStartAction): CommonState {
  return {
    ...state
    // isLoadingFileList: true
  };
}
function handleAttachFileSuccess(state: CommonState, action: AttachFileSuccessAction): CommonState {
  if (!action.fileVMs) {
    return state;
  }
  var fileVMs: FileViewModel[] = state.fileVMs ? state.fileVMs.splice(0) : [];
  action.fileVMs.forEach(element => {
    fileVMs.push(element);
  });
  return {
    ...state,
    fileVMs: fileVMs
    // isLoadingFileList: false
  };
}
function handleAttachFileFailure(state: CommonState, action: AttachFileFailureAction): CommonState {
  return {
    ...state,
    errorMessage: action.errorMessage
    // isLoadingFileList: false
  };
}

function handleResetFileAttachForm(state: CommonState, action: ResetFileAttachFormAction): CommonState {
  return {
    ...state,
    fileVMs: []
  };
}

function handleAbstractGetInit(state: CommonState, action: InitGetResultAction): CommonState {
  return {
    ...state
  };
}

function handleAbstractGetSuccess(state: CommonState, action: SuccessGetResultAction<Object>): CommonState {
  return {
    ...state
  };
}

function handleAbstractGetFailure(state: CommonState, action: GetResultFailureAction): CommonState {
  return {
    ...state
  };
}

function handleSetFileListLoading(state: CommonState, action: SetFileListLoadingAction): CommonState {
  return {
    ...state,
    isLoadingFileList: action.isFileListLoading
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const CommonReducer = createReducer(initialState, {
  [CommonActionType.LoadStatesStart]: handleLoadStatesStart,
  [CommonActionType.LoadStatesSuccess]: handleLoadStatesSuccess,
  [CommonActionType.LoadStatesFailure]: handleLoadStatesFailure,

  [CommonActionType.ToggleModal]: handleToggleModal,
  [CommonActionType.ToggleDialog]: handleToggleDialog,

  [CommonActionType.CommonVerifyAddressStart]: handleAddressVerificationStart,
  [CommonActionType.CommonVerifyAddressSuccess]: handleAddressVerificationSuccess,
  [CommonActionType.CommonVerifyAddressFail]: handleAddressVerificationFail,

  /********** AttachFile **********/
  [CommonActionType.AttachFileStart]: handleAttachFileStart,
  [CommonActionType.AttachFileSuccess]: handleAttachFileSuccess,
  [CommonActionType.AttachFileFailure]: handleAttachFileFailure,

  [CommonActionType.AbstractGetInit]: handleAbstractGetInit,
  [CommonActionType.AbstractGetSuccess]: handleAbstractGetSuccess,
  [CommonActionType.AbstractGetFailure]: handleAbstractGetFailure,
  [CommonActionType.ResetFileAttachForm]: handleResetFileAttachForm,

  [CommonActionType.SetFileListLoading]: handleSetFileListLoading
});



// WEBPACK FOOTER //
// ./src/common/components/common.reducer.ts